import { Edit, SimpleForm, useTranslate } from 'react-admin';
import { ContractEditFormContents, ConfirmSaveToolbar } from '../../common_modules/components/ContractEditFormContents';
import useErrorHandler from '../../common_modules/hooks/useErrorHandler';

export const ContractSettingsEdit = () => {
  const handleError = useErrorHandler();
  const translate = useTranslate();

  const formProps = {
    fileInputLabel: translate('resources.contract-settings.fields.contents'),
    agreementChangeWarningText: translate('resources.contract-settings.fields.agreementChangeWarningText'),
    dialogTitle: translate('resources.contract-settings.fields.dialogTitle')
  };

  const Title = () => {
    return <span>{translate('resources.contract-settings.name')}</span>;
  };
  return (
    <Edit title={<Title />} mutationMode="pessimistic" mutationOptions={{ onError: handleError }} redirect={false}>
      <SimpleForm
        toolbar={
          <ConfirmSaveToolbar
            agreementChangeWarningText={formProps.agreementChangeWarningText}
            dialogTitle={formProps.dialogTitle}
          />
        }
        sx={{ maxWidth: '600px' }}
      >
        <ContractEditFormContents {...formProps} />
      </SimpleForm>
    </Edit>
  );
};
